export default {
    methods: {
        handleError(error) {

            if (!(error instanceof Object) || !error.response) {

                throw error
            }

            let message = ''

            switch (error.response.status) {

                case 400:
                case 401:
                case 403: {

                    if (error.response.data.message) {

                        message = error.response.data.message
                    }

                    break;
                }
                case 422: {

                    let errorMessages = ''

                    for (const key in error.response.data) {

                        if (Array.isArray(error.response.data[key])) {

                            errorMessages += error.response.data[key].map(msg => `<li>${msg}</li>`).join('')

                            continue
                        }

                        errorMessages.push(error.response.data[key])
                    }

                    message = `<ul class="m-0">${errorMessages}</ul>`

                    break
                }
                default: {

                    message = 'Ocorreu um erro'

                    break
                }
            }

            if (!message) return

            this.showValidationNotification(message)
        }
    }
}